import { Link } from "react-router-dom";
export default function NotFoundPage() {
  return (
    <section className="pageSection pageWithHeaderOffset">
      <div className="container">
        <div className="card">
          <h1 className="h1">Nie znaleziono strony</h1>
          <p className="pageLead">Adres nie istnieje albo został jeszcze niepodłączony.</p>
          <Link to="/" className="btn">Wróć na stronę główną</Link>
        </div>
      </div>
    </section>
  );
}